import { render, staticRenderFns } from "./brand_selector.vue?vue&type=template&id=c1ee519c"
import script from "./brand_selector.vue?vue&type=script&lang=js"
export * from "./brand_selector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports